import { ICancerRejectionList } from '@nkr/models/cancer-rejection-list';
import { IListItem } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, FormControl, Panel, Row } from 'react-bootstrap';

interface IProps {
    cancerRejectionList: ICancerRejectionList[],
    cancerTypeList: IListItem[],
    statusList: IListItem[],
    onChange: (index: number, field: string, e: EventTarget) => void,
    onAdd: () => void,
    onRemove: (index: number, type: string) => void
}

const CancelRejectionList = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Rule out on Cancer History</Panel.Heading>
            <Panel.Body>
                <Alert bsStyle='warning'>
                    If you would like to rule-out for certain cancers or require a length of remission before allowing a donor to proceed, add the cancer and remission required below.
                    <br />
                    If you do not wish to rule out on a cancer at all (e.g., skin cancer), then do not add an entry for it.
                </Alert>
                <Row className='hidden-xs'>
                    <Col xs={5}><strong>Cancer</strong></Col>
                    <Col xs={5}><strong>Remission Required</strong></Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        {props.cancerRejectionList.map((rule, index) => (
                            <Row key={index} className='row-margined xs-only-form-box'>
                                <Col xs={12} sm={3}>
                                    <ControlLabel className='visible-xs' htmlFor={`CancerType${index}`}>Cancer</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        className='form-control'
                                        id={`CancerType${index}`}
                                        value={rule.id}
                                        onChange={(e) => props.onChange(index, 'id', e.target)}
                                    >
                                        {props.cancerTypeList.map((cause, index) =>
                                            <option key={index} value={cause.id}>{cause.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                                <Col xs={12} sm={3} className='padtop-xs'>
                                    <ControlLabel className='visible-xs' htmlFor={`RemissionStatus${index}`}>Remission Required</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        className='form-control'
                                        id={`RemissionStatus${index}`}
                                        value={rule.remission}
                                        onChange={(e) => props.onChange(index, 'remission', e.target)}
                                    >
                                        <option value=''>Always Rule Out</option>
                                        {props.statusList.map((cause, index) =>
                                            <option key={index} value={cause.id}>{cause.description}</option>
                                        )}
                                    </FormControl>
                                </Col>
                                <Col xs={12} sm={2} className='padtop-xs'>
                                    <Button bsStyle='danger' block onClick={() => props.onRemove(index, 'cancer')}>Remove</Button>
                                </Col>
                                <Col xs={12} className='visible-xs'>&nbsp;</Col>
                            </Row>
                        ))}
                    </Col>
                    <Col xs={12}>
                        <div style={{ marginTop: 10 }}>
                            <Button bsStyle='primary' onClick={props.onAdd}>
                                Add Cancer Rule Out
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Panel.Body>
        </Panel>
    );
}

export default CancelRejectionList;